module.exports = __webpack_public_path__ + "static/media/Desktop.26aff2d1.jpg";